/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CourierPackageImportFromJaShippersRequest
 */
export interface CourierPackageImportFromJaShippersRequest {
    /**
     * ID of the courier
     * @type {string}
     * @memberof CourierPackageImportFromJaShippersRequest
     */
    courierId: string;
}

/**
 * Check if a given object implements the CourierPackageImportFromJaShippersRequest interface.
 */
export function instanceOfCourierPackageImportFromJaShippersRequest(value: object): value is CourierPackageImportFromJaShippersRequest {
    if (!('courierId' in value) || value['courierId'] === undefined) return false;
    return true;
}

export function CourierPackageImportFromJaShippersRequestFromJSON(json: any): CourierPackageImportFromJaShippersRequest {
    return CourierPackageImportFromJaShippersRequestFromJSONTyped(json, false);
}

export function CourierPackageImportFromJaShippersRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourierPackageImportFromJaShippersRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'courierId': json['courierId'],
    };
}

export function CourierPackageImportFromJaShippersRequestToJSON(json: any): CourierPackageImportFromJaShippersRequest {
    return CourierPackageImportFromJaShippersRequestToJSONTyped(json, false);
}

export function CourierPackageImportFromJaShippersRequestToJSONTyped(value?: CourierPackageImportFromJaShippersRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'courierId': value['courierId'],
    };
}

